export default __webpack_public_path__ + "static/media/app-name.116ef3d5.png";